import { gql } from "gql";

export const SAVE_DYNAMIC_PROCESS = gql(/* GraphQL */ `
  mutation SaveEntityBasedDynamicProcessModel(
    $process: EntityBasedDynamicProcessInput!
  ) {
    saveEntityBasedDynamicProcessModel(process: $process) {
      id
    }
  }
`);
